import { render, staticRenderFns } from "./FreeAccessCelebration.vue?vue&type=template&id=4b15730e&scoped=true&"
import script from "./FreeAccessCelebration.vue?vue&type=script&lang=js&"
export * from "./FreeAccessCelebration.vue?vue&type=script&lang=js&"
import style0 from "./FreeAccessCelebration.vue?vue&type=style&index=0&id=4b15730e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b15730e",
  null
  
)

export default component.exports